import React from "react";
import { Link } from "react-router-dom";
import type { SidebarMenuItem } from "../types";
import { useSidebarSelection } from "../hooks/useSidebarSelection";

interface SidebarNavItemProps {
  item: SidebarMenuItem;
}

export function SidebarNavItem({ item }: SidebarNavItemProps) {
  const isSelected = useSidebarSelection(item);
  const { name, href, onClick, Icon } = item;

  // Neutral-dark items; teal reserved for the active item, shown as an inset rounded
  // row that doesn't bleed to the edge (016 §5 / review §4.1, §6).
  const baseStyles =
    "group flex flex-row items-center gap-3 mx-2 px-3 py-2 text-sm rounded-md font-medium transition-colors";
  const stateStyles = isSelected
    ? "bg-accent text-primary font-semibold"
    : "text-muted-foreground hover:bg-accent hover:text-foreground";
  const className = `${baseStyles} ${stateStyles}`.trim();

  if (href) {
    if (href.startsWith("http") || href.startsWith("mailto")) {
      return (
        <a href={href} className={`link-reset ${className}`}>
          <Icon className="w-5 h-5 shrink-0" aria-hidden="true" />
          <span>{name}</span>
        </a>
      );
    }

    return (
      <Link to={href} className={`link-reset ${className}`}>
        <Icon className="w-5 h-5 shrink-0" aria-hidden="true" />
        <span>{name}</span>
      </Link>
    );
  }

  if (onClick) {
    return (
      <button onClick={onClick} className={`${className} w-[calc(100%-1rem)]`}>
        <Icon className="w-5 h-5 shrink-0" aria-hidden="true" />
        <span>{name}</span>
      </button>
    );
  }

  return null;
}

